import { useUser } from "@clerk/clerk-react";
import * as Sentry from "@sentry/react";
import { useEffect } from "react";

/**
 * SentryUserTracker syncs authenticated user identity from Clerk to Sentry scope.
 * This ensures all frontend errors, breadcrumbs, and session replays are attributed
 * to the exact user, allowing immediate lookup by user ID or email.
 */
export function SentryUserTracker() {
  const { user, isLoaded, isSignedIn } = useUser();

  useEffect(() => {
    if (!isLoaded) return;

    if (isSignedIn && user) {
      Sentry.setUser({
        id: user.id,
        email: user.primaryEmailAddress?.emailAddress,
        username: user.fullName || user.username || undefined,
      });
    } else {
      Sentry.setUser(null);
    }
  }, [user, isLoaded, isSignedIn]);

  return null;
}
